import frCommonMessages from "../locales/fr_FR.json";

let FrLang = {
    messages: {
        ...frCommonMessages,
    },
    locale: "fr-FR",
};

if (process.env.REACT_APP_PROJECT === "taxi") {
    const frProjectMessages = require(`../locales/${process.env.REACT_APP_PROJECT}/fr_FR.json`);
    const frCustomersMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Customers/locales/fr_FR.json`);
    const frLimitsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Limits/locales/fr_FR.json`);
    const frCustomersReportsMessages = require(
        `${process.env.REACT_APP_MODULES_DIR}/CustomersReports/locales/fr_FR.json`,
    );
    const frTariffsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Tariffs/locales/fr_FR.json`);
    const frCitiesMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Cities/locales/fr_FR.json`);
    const frCoordinatorsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Coordinators/locales/fr_FR.json`);
    const frProvidersMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Providers/locales/fr_FR.json`);
    const frEmployeesMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Employees/locales/fr_FR.json`);
    const frHelpRequestsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/HelpRequests/locales/fr_FR.json`);
    const frOrdersMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Orders/locales/fr_FR.json`);
    const frManagersMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Managers/locales/fr_FR.json`);
    const frAccessTokensMessages = require(`${process.env.REACT_APP_MODULES_DIR}/AccessTokens/locales/fr_FR.json`);
    const frAdminsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Admins/locales/fr_FR.json`);
    const frRolesMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Roles/locales/fr_FR.json`);
    const frAuthMessages = require(`modules/Auth/locales/fr_FR.json`);
    const frUsersMessages = require(`modules/Users/locales/fr_FR.json`);
    const frAnalyticsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Analytics/locales/fr_FR.json`);

    FrLang = {
        messages: {
            ...frCommonMessages,
            ...frProjectMessages,
            ...frAnalyticsMessages,
            ...frCustomersMessages,
            ...frLimitsMessages,
            ...frCustomersReportsMessages,
            ...frCoordinatorsMessages,
            ...frProvidersMessages,
            ...frTariffsMessages,
            ...frCitiesMessages,
            ...frEmployeesMessages,
            ...frOrdersMessages,
            ...frHelpRequestsMessages,
            ...frAdminsMessages,
            ...frManagersMessages,
            ...frAccessTokensMessages,
            ...frRolesMessages,
            ...frAuthMessages,
            ...frUsersMessages,
        },
        locale: "fr-FR",
    };
}

export default FrLang;
